"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _clapprHlsFix = require("clappr-hls-fix");

var _Discussion = require("../Discussion");

var _class, _temp, _class3, _descriptor, _temp2, _class5, _descriptor2, _temp3, _class7, _descriptor3, _temp4, _class9, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp5;

var VideoBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(VideoBody, _Component);

  function VideoBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.videoContainer = null;
    return _this;
  }

  babelHelpers.createClass(VideoBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("div", {
        className: "video-body",
        ref: this.gotVideoContainer
      }), _react.default.createElement("div", {
        className: "comment-text",
        style: {
          whiteSpace: 'pre-line'
        }
      }, this.props.children));
    }
  }, {
    key: "gotVideoContainer",
    value: function gotVideoContainer(node) {
      if (this.videoContainer != node) {
        if (this.videoContainer) {
          this.player.destroy();
        }

        this.videoContainer = node;

        if (this.videoContainer) {
          var w = this.videoContainer.offsetWidth;
          var h = w / 800 * 450;
          var opts = {
            source: this.props.video.video,
            poster: this.props.video.thumbnail,
            width: w,
            height: h
          };
          this.player = (0, _clapprHlsFix.getFixedClappr)(opts);
          this.player.attachTo(this.videoContainer);
        }
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (this.videoContainer) {
        var w = this.videoContainer.offsetWidth;
        var h = w / 800 * 450;
        this.player.resize({
          width: w,
          height: h
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      $(window).on('resize', this.resize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player) {
        this.player.destroy();
      }

      $(window).off('resize', this.resize);
    }
  }]);
  return VideoBody;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotVideoContainer", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotVideoContainer"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "resize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype)), _class);
var VideoHeader = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(VideoHeader, _Component2);

  function VideoHeader() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, VideoHeader);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(VideoHeader)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(VideoHeader, [{
    key: "render",
    value: function render() {
      var accepted = this.node.children.filter(function (v) {
        return v.node.child_type == 'accept';
      })[0];
      var rejected = this.node.children.filter(function (v) {
        return v.node.child_type == 'reject';
      })[0];

      if (accepted) {
        return _react.default.createElement(AssignmentAccepted, {
          node: accepted
        });
      }

      if (rejected) {
        return _react.default.createElement(AssignmentRejected, {
          node: rejected
        });
      }

      return null;
    }
  }]);
  return VideoHeader;
}(_react.Component), _temp2), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var AssignmentAccepted = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(AssignmentAccepted, _Component3);

  function AssignmentAccepted() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, AssignmentAccepted);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(AssignmentAccepted)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "node", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(AssignmentAccepted, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "assignment-header accepted"
      }, _react.default.createElement("h1", null, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "check_circle"
      }), "Assignment Accepted"));
    }
  }]);
  return AssignmentAccepted;
}(_react.Component), _temp3), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
var AssignmentRejected = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(AssignmentRejected, _Component4);

  function AssignmentRejected() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, AssignmentRejected);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(AssignmentRejected)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "node", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(AssignmentRejected, [{
    key: "render",
    value: function render() {
      // FIXME: render a component here
      return null;
    }
  }]);
  return AssignmentRejected;
}(_react.Component), _temp4), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
var VideoNode = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(VideoNode, _Component5);

  function VideoNode() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, VideoNode);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(VideoNode)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "node", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "commentPosted", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "defaultCollapsed", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "trackData", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "discussion", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      expanded: false,
      userProfile: null,
      submitting: false,
      action: 'reply',
      collapsed: _this5.defaultCollapsed
    };
    return _this5;
  }

  babelHelpers.createClass(VideoNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          child_type: this.state.action,
          parent: this.node.node.id,
          comment: comment,
          trackData: this.trackData
        })
      }).then(function (result) {
        if (result.status == 204) return true;
        if (result.ok) return result.json();
        throw result.json();
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this6 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this6.setState({
          submitting: true
        }, function () {
          _this6.doPostComment(comment).then(function (result) {
            _this6.setState({
              submitting: false,
              action: 'reply'
            }, function () {
              (0, _noty.showNotificationText)('Your comment has been posted.');

              _this6.commentPosted();

              resolve(true);
            });
          }).catch(function (error) {
            _this6.setState({
              submitting: false
            }, function () {
              reject(error);
            });
          });
        });
      });
    }
  }, {
    key: "setAction",
    value: function setAction(node) {
      this.setState({
        action: node.target.value
      });
    }
  }, {
    key: "expand",
    value: function expand() {
      this.setState({
        collapsed: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(VideoHeader, {
          node: this.node
        }), _react.default.createElement(_node.default, {
          node: this.node.node,
          collapsed: this.state.collapsed,
          discussion: this.discussion,
          image: this.node.node.signedVideo.thumbnail,
          expand: this.expand,
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          oldFooter: _react.default.createElement("footer", null, _react.default.createElement("div", {
            className: "submit"
          }, this.node.node.permissions.reply ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doReply,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "reply"
          }), "\xA0 Reply") : null, this.node.node.permissions.delete ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doDelete,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "delete"
          }), "\xA0 Delete") : null))
        }, _react.default.createElement(VideoBody, {
          video: this.node.node.signedVideo
        }, this.node.node.comment)), !this.state.collapsed ? _react.default.createElement("section", {
          className: _classList.default.join('child-comments', this.state.expanded && 'open')
        }, _react.default.createElement("div", {
          className: "sub-comment-list"
        }, this.node.children.length ? this.node.children.map(function (child) {
          return _react.default.createElement(_Discussion.DiscussionNode, {
            discussion: _this7.discussion,
            trackData: _this7.trackData,
            key: child.node.id,
            commentPosted: _this7.commentPosted,
            node: child
          });
        }) : null), this.node.node.permissions.reply ? _react.default.createElement("div", {
          className: _classList.default.join('comment-form', this.node.node.permissions.canGrade ? 'grading-form' : '')
        }, _react.default.createElement(_commentForm.default, {
          placeholder: "Enter a reply...",
          submitComment: this.submitComment,
          submitting: this.state.submitting,
          userProfile: this.state.userProfile,
          gotCommentField: this.gotCommentField,
          acceptEmptyComment: this.state.action != 'reply'
        }), this.node.node.permissions.canGrade ? _react.default.createElement("div", {
          className: "comment-form-actions"
        }, _react.default.createElement("div", {
          className: "radio"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "radio",
          value: "reply",
          onClick: this.setAction,
          checked: this.state.action == 'reply'
        }), "Comment Only")), _react.default.createElement("div", {
          className: "radio"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "radio",
          value: "accept",
          onClick: this.setAction,
          checked: this.state.action == 'accept'
        }), "Accept Assignment")), _react.default.createElement("div", {
          className: "radio"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "radio",
          value: "reject",
          onClick: this.setAction,
          checked: this.state.action == 'reject'
        }), "Request New Upload"))) : null) : null) : null);
      }

      return null;
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this8 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The video has been deleted.');

        _this8.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(field) {
      this.commentField = field;
    }
  }, {
    key: "toggleExpando",
    value: function toggleExpando() {
      this.setState(function (st) {
        return {
          expanded: !st.expanded
        };
      });
    }
  }, {
    key: "doReply",
    value: function doReply() {
      var _this9 = this;

      this.setState({
        expanded: true
      }, function () {
        _this9.commentField.focus();
      });
    }
  }]);
  return VideoNode;
}(_react.Component), _temp5), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "defaultCollapsed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "profileUpdatedEvent"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "profileUpdated"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "submitComment"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "setAction", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "setAction"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "expand", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "expand"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "doDelete"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotCommentField"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "toggleExpando", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "toggleExpando"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "doReply", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "doReply"), _class9.prototype)), _class9);
exports.default = VideoNode;